export default async function getCookieNotice() {
	const cookieNotice = await import(/* webpackChunkName: "cookie-notice-async" */ '../base/cookie-notice');
	return;
}